import { render, staticRenderFns } from "./ExamListAddNew.vue?vue&type=template&id=d6f36a2c&"
import script from "./ExamListAddNew.vue?vue&type=script&lang=js&"
export * from "./ExamListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ExamListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports